/**
 * The small spinner shown while a record's submission is still being processed. Same markup as the
 * Inventory Request status cells, so both record kinds show the same icon.
 * @module src/components/Shared/SubmissionInFlightIcon
 */
import React, { CSSProperties, FC } from 'react';
import Spinner from '@salesforce/design-system-react/components/spinner';
import { SUBMISSION_IN_FLIGHT_ICON_LABEL } from '../../../util/constants';

/**
 * The design system's spinner container sits at z-index 9050 on a white background, above dialogs and
 * their backdrop. z-index 0 keeps the spinner in its own layer under them, and a transparent background
 * removes the pale square on gray headers and rows. The spinner's dots bounce outside its 1rem box and
 * the page header title hides overflow, so the container is positioned absolutely with auto offsets: it
 * stays exactly where it would sit in the flow, but outside the title's clipping.
 */
const SPINNER_CONTAINER_STYLE: CSSProperties = {
  position: 'absolute',
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto',
  zIndex: 0,
  height: '1rem',
  width: '1rem',
  backgroundColor: 'transparent',
};

const SubmissionInFlightIcon: FC = () => (
  <div
    title={SUBMISSION_IN_FLIGHT_ICON_LABEL}
    style={{ marginLeft: '5px', display: 'flex', alignItems: 'center', width: '1rem' }}
  >
    <Spinner
      size="x-small"
      variant="base"
      assistiveText={{ label: SUBMISSION_IN_FLIGHT_ICON_LABEL }}
      containerStyle={SPINNER_CONTAINER_STYLE}
    />
  </div>
);

export default SubmissionInFlightIcon;
